export const module = {
  info: {
    name: 'voip-sms-panel',
    caption: 'voip sms panel',
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
